import { useQuery } from '@tanstack/react-query';
import apiClient from './api-client';
const FEATUREFLAG = 'feature-flags';
const LIST = 'list';
const fiveMinutes = 300000;
const keysFactory = {
    allFeatureFlags: (financingProgram) => [{ scope: FEATUREFLAG, entity: LIST, financingProgram }],
};
const createGetFeatureFlagsList = (financingProgram) => {
    return async () => {
        const response = await apiClient.get(`${financingProgram}/FeatureFlag`);
        return response.data;
    };
};
export function useFeatureFlags(financingProgram) {
    const getFeatureFlagsList = createGetFeatureFlagsList(financingProgram);
    const { isFetching, data } = useQuery({
        queryKey: keysFactory.allFeatureFlags(financingProgram),
        queryFn: getFeatureFlagsList,
        staleTime: fiveMinutes,
        gcTime: fiveMinutes,
    });
    return [data, isFetching];
}
